import { m } from "@vega-core/paraglide/messages";

import { celestialArticles } from "../data/celestialArticles";
import { celestialFaqs } from "../data/celestialFaqs";

import { ResourcesPage } from "./ResourcesPage";

export const CelestialArticlesPage = () => (
  <ResourcesPage
    articles={celestialArticles}
    description={m.localcms_celestial_resources_description()}
    faqSections={celestialFaqs}
    title={m.localcms_celestial_resources_title()}
  />
);
